/**
* Tickets Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Tickets Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'tickets-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.tickets-banner .jump-link' ).click( function() {
        if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
          let target = $( this.hash );
          let wpadminBarHeight = 0;
          if ( $( '#wpadminbar' ).length > 0 ) {
            wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
          }
          const headerHeight = $( 'header.navbar' ).outerHeight();
          target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) +']' );
          if ( target.length ) {
            $( 'html, body' ).animate( {
              scrollTop: target.offset().top - ( headerHeight + wpadminBarHeight ),
            }, 1000 );
            return false;
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'tickets-banner', COMPONENT );
} )( app );
